import {getNewOutlet} from 'reconnect.js';

getNewOutlet('extra', {}, {autoDelete: false});
